import { classNames } from 'libs/react';
import { useRef } from 'libs/react';
import { Reveal } from './private/Reveal';
import { React } from 'libs/react';
import './FormField.scss';
/**
 * @component FormField
 * @since 1.0.0
 */
export function FormField(props) {
    const { style, ratio, enter, leave } = Object.assign({ style: 'normal', ratio: 0 }, props);
    const node = useRef(null);
    /*
    const [bounds] = useMeasure(node);
  
    useEffect(() => {
      if (node.current) {
        node.current.style.setProperty(
          '--scroll-width',
          node.current.scrollWidth + 'px'
        );
        node.current.style.setProperty(
          '--scroll-height',
          node.current.scrollHeight + 'px'
        );
      }
    }, [bounds.width, bounds.height]);
    */
    const className = classNames('form-field', 'form-field--' + style, 'form-field--' + ratio, props.className);
    return (React.createElement(Reveal, { enter: enter, leave: leave, presentClassName: "form-field--present", dismissClassName: "form-field--dismiss" },
        React.createElement("div", { ref: node, className: className }, props.children)));
}
